import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { useScrollPosition } from "../hooks/useScrollPosition";
import logo from "../images/logo.png";
import "../css/header.css";

const Header: React.FC = () => {
  const { lang, t, toggleLanguage } = useLanguage();
  const scrollY = useScrollPosition();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <header className={`header${scrollY > 100 ? " scrolled" : ""}`}>
      <div className="container">
        <a href="#home" className="header-logo">
          <img src={logo} alt="Logo Daniel" />
        </a>

        <div
          className={`hamburger${menuOpen ? " active" : ""}`}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </div>

        <nav className={`nav${menuOpen ? " open" : ""}`}>
          <ul className="nav-list">
            <li>
              <a href="#about" className="nav-link" onClick={handleNavClick}>
                <i className="fa-solid fa-user" />
                <span>{t.navAbout}</span>
              </a>
            </li>
            <li>
              <a href="#skills" className="nav-link" onClick={handleNavClick}>
                <i className="fa-solid fa-code" />
                <span>{t.navSkills}</span>
              </a>
            </li>
            <li>
              <a href="#projects" className="nav-link" onClick={handleNavClick}>
                <i className="fa-solid fa-folder-open" />
                <span>{t.navProjects}</span>
              </a>
            </li>
            <li className="language-toggle">
              <i className="fa-solid fa-globe" />
              <div
                className={`toggle-switch${lang === "en" ? " active" : ""}`}
                onClick={toggleLanguage}
              />
              <span className="language-label">{lang === "pt" ? "PT" : "EN"}</span>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
